module.exports = __webpack_public_path__ + "img/diners-club.4aafd8e1.svg";